import { scriptService } from '@/services/script/script.service'
import type { ExecuteScriptParams } from '@/services/script/types.ts'
import type { JSResult } from '@/services/script/types'
import type { JsRequest } from '@/services/websocket/types'
import { ScriptLevel, ScriptName } from '@/services/websocket/types'
import { onMounted, onUnmounted } from 'vue'
import type En from '@/common/classes/En.ts'

export function useScript() {
  const executeScript = async (params: ExecuteScriptParams, en: En): Promise<JSResult> => {
    return scriptService.executeScript(params, en)
  }

  const registerJsRequestHandler = (handler: (request: JsRequest) => Promise<any>) => {
    return scriptService.registerJsRequestHandler(handler)
  }

  const getSocketId = () => {
    return scriptService.getSocketId()
  }

  return {
    executeScript,
    registerJsRequestHandler,
    getSocketId
  }
}

export function useScriptAutoHandler(handler: (request: JsRequest) => Promise<any>) {
  let unsubscribe: (() => void) | null = null

  onMounted(() => {
    unsubscribe = scriptService.registerJsRequestHandler(handler)
  })

  onUnmounted(() => {
    if (unsubscribe) {
      unsubscribe()
    }
  })
}

export { ScriptLevel, ScriptName }

